// src/msalConfig.js

import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        navigateToLoginRequestUrl: false, // Prevents redirect back to /login which causes 404
        clientId: "540d854f-c10a-4072-a571-0446ed7d7826", // Replace with your client ID
        authority: "https://login.microsoftonline.com/9ec212c2-2f63-4e82-a59a-5e479388ba2a", // Replace with your tenant ID
        redirectUri: window.location.origin, // Simplified: use the base URL for redirect
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    }
};

console.log("MSAL Redirect URI configured as:", msalConfig.auth.redirectUri);

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
